// Helper function to safely decode and fix email parameter
export default function getEmailFromParams(params: URLSearchParams): string {
  const rawEmail = params.get('email') || '';
  if (!rawEmail) return '';
  try {
    let email = rawEmail;
    // Decode URL encoding (handle potential double encoding)
    let previousEmail = '';
    while (email !== previousEmail && email.includes('%')) {
      previousEmail = email;
      email = decodeURIComponent(email);
    }
    // Replace spaces with + only if there's no evidence of proper + encoding
    // Check for both %2B and %2b (case insensitive) and existing + signs
    const hasProperPlusEncoding = /(%2b|%2B|\+)/i.test(rawEmail);
    if (!hasProperPlusEncoding) {
      const [localPart, domain] = email.split('@');
      if (localPart && domain) {
        const fixedLocalPart = localPart.replace(/\s+/g, '+');
        return `${fixedLocalPart}@${domain}`;
      }
    }
    return email;
  } catch (error) {
    console.warn('Failed to decode email parameter:', error);
    return rawEmail;
  }
}
